import { render, staticRenderFns } from "./PersonalTabItem.vue?vue&type=template&id=1ca825e2&scoped=true&"
import script from "./PersonalTabItem.vue?vue&type=script&lang=js&"
export * from "./PersonalTabItem.vue?vue&type=script&lang=js&"
import style0 from "./PersonalTabItem.vue?vue&type=style&index=0&id=1ca825e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca825e2",
  null
  
)

export default component.exports